import { useState } from 'react';
import { useOasisBackend } from '../../hooks/useOasisBackend';
import { EntityCollection, EntityMetadataResponse } from '../../api/OasisBackendApi';
import MetadataModal from './entityInjestion/MetadataModal';
import { toast, ToastContainer } from 'react-toastify';

const EntityUploader = ({DatabaseId, setEntityCollection, fetchAllEntities}: {DatabaseId: string, setEntityCollection: (entityCollection: EntityCollection) => void, fetchAllEntities?: () => void}) => {
    const db = useOasisBackend();
    const [file, setFile] = useState<File | null>(null);
    const [metadata, setMetadata] = useState<EntityMetadataResponse | null>(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setFile(file);
        }
    };

    const handleUpload = async () => {
        if (!file) return;
        
        setLoading(true);
        const formData = new FormData();
        formData.append('csv_file', file);
        
        try {
            const response = await db.endpoints.api.apiDatabaseGenerateEntityMetadataCreate(DatabaseId, {csv_file: file});
            
            setMetadata(response.data);
            setShowModal(true);
        } catch (error) {
            console.error('Error uploading file:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveMetadata = async (editedMetadata: EntityMetadataResponse) => {
        if (!file || saving) return;

        setSaving(true);
        setMetadata(editedMetadata);
        try {
            const formData = new FormData();
            formData.append('csv_file', file);
            const response = await db.endpoints.api.apiDatabaseUploadEntitiesCreate(DatabaseId, {
                csv_file: file,
                entity_collection_metadata: editedMetadata 
            });
            if (response.status === 201) {
                toast.success('Entities added successfully');
                setEntityCollection(response.data);
                if (fetchAllEntities) {
                    fetchAllEntities();
                }
                setShowModal(false);
            } else {
                toast.error('Failed to add entities');
            }
            // setShowModal(false);
        } catch (error) {
            console.error('Error saving metadata:', error);
            toast.error('Error saving metadata');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="flex flex-col gap-3 sm:gap-4 p-3 sm:p-4">
            <input 
                type="file" 
                onChange={handleFileChange} 
                accept=".csv"
                className="text-sm sm:text-base"
            />
            <button 
                className="w-fit px-4 sm:px-6 py-2 sm:py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-gray-800 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base" 
                onClick={handleUpload} 
                disabled={!file || loading}
            >
                {loading ? 'Generating Metadata...' : 'Add Entities'}
            </button>
            
            {showModal && metadata && (
                <MetadataModal
                    metadata={metadata}
                    saveButtonText="Confirm and Upload Entities"
                    onClose={() => setShowModal(false)}
                    onSave={handleSaveMetadata}
                    isLoading={saving}
                />
            )}
        </div>
    )
}

export default EntityUploader;